<template>
  <div>
    <div class="container-fluid mb-5 mb-md-0 pb-5 pb-md-0">
      <div class="row align-content-center">
        <!-- COLOR HALF -->
        <div class="col-md-6 col-lg-6 col-xl-6 section-login-left-gradient h-100 d-none d-md-block">
          <div class="text-center section-login-text">
            <typical
                class="typicalWrapper fw-bold text-shadow-sm"
                :steps="['Create.', 2000, 'Design.', 2000, 'Color.', 2000]"
                :loop="3"
                :wrapper="'h2'"
            ></typical>
          </div>
        </div>
        <!-- FORM HALF -->
        <div class="col-md-6 col-lg-6 col-xl-6 align-self-center">
          <div class="row justify-content-center">
            <div class="col-md-12 col-xxl-8">
              <div class="card bg-transparent shadow-0dp">
                <div class="card-header bg-transparent d-flex justify-content-between my-3">
                  <h5 class="fw-500 mb-3">Sign Up</h5>
                  <router-link to="/">
                    <img src="@/assets/img/logos/logo-form.svg" width="50px" class="img-logo img-fluid mb-3"
                         alt="Colorffy logo">
                  </router-link>
                </div>
                <div class="card-body">
                  <!-- SOCIAL MEDIA LOGIN -->
                  <div class="row mb-2">
                    <div class="col-md-12">
                      <h6 class="subtitle-1 text-muted">Sign up with</h6>
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-md-12 col-xl-4">
                      <button class="btn btn-default btn-w-100 btn-round ripple ripple-primary px-3"
                              @click="onClickLogin('Google')">
                        <svg width="24" height="24" class="me-2">
                          <g fill="none" fill-rule="evenodd">
                            <path
                                d="M20.66 12.7c0-.61-.05-1.19-.15-1.74H12.5v3.28h4.58a3.91 3.91 0 0 1-1.7 2.57v2.13h2.74a8.27 8.27 0 0 0 2.54-6.24z"
                                fill="#4285F4"></path>
                            <path
                                d="M12.5 21a8.1 8.1 0 0 0 5.63-2.06l-2.75-2.13a5.1 5.1 0 0 1-2.88.8 5.06 5.06 0 0 1-4.76-3.5H4.9v2.2A8.5 8.5 0 0 0 12.5 21z"
                                fill="#34A853"></path>
                            <path
                                d="M7.74 14.12a5.11 5.11 0 0 1 0-3.23v-2.2H4.9A8.49 8.49 0 0 0 4 12.5c0 1.37.33 2.67.9 3.82l2.84-2.2z"
                                fill="#FBBC05"></path>
                            <path
                                d="M12.5 7.38a4.6 4.6 0 0 1 3.25 1.27l2.44-2.44A8.17 8.17 0 0 0 12.5 4a8.5 8.5 0 0 0-7.6 4.68l2.84 2.2a5.06 5.06 0 0 1 4.76-3.5z"
                                fill="#EA4335"></path>
                          </g>
                        </svg>
                        Google
                      </button>
                    </div>
                    <div class="col-md-12 col-xl-4">
                      <button class="btn btn-default btn-w-100 btn-round ripple ripple-primary px-3"
                              @click="onClickLogin('Twitter')">
                        <img class="img-fluid me-2" width="24px"
                             src="@/assets/img/icons/twitter-fill.svg"
                             alt="Twitter">
                        Twitter
                      </button>
                    </div>
                    <div class="col-md-12 col-xl-4">
                      <button class="btn btn-default btn-w-100 btn-round ripple ripple-primary px-3"
                              @click="onClickLogin('Github')">
                        <img class="img-fluid img-logo me-2" width="24px"
                             src="@/assets/img/icons/github-fill.svg"
                             alt="Twitter">
                        GitHub
                      </button>
                    </div>
                  </div>
                  <hr>
                  <div class="col-md-12 mb-3">
                    <h6 class="subtitle-1 text-muted">Or register with your email</h6>
                  </div>
                  <!-- FORM -->
                  <div class="mb-3">
                    <div v-if="error" class="alert alert-danger"><i class="material-icons-outlined me-2">error</i>
                      {{ error }}
                    </div>
                    <form action="" @submit.prevent="onSubmit">
                      <div class="form-floating mb-3">
                        <input type="text" class="form-control" id="inputName" placeholder="Alex" required
                               autofocus v-model="form.name">
                        <label for="inputName">Name</label>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="email" class="form-control" id="inputEmail" placeholder="name@example.com" required
                               v-model="form.email">
                        <label for="inputEmail">Email address</label>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="password" class="form-control" id="inputPassword" placeholder="Password" required
                               v-model="form.password">
                        <label for="inputPassword">Password</label>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="password" class="form-control" id="inputConfirmPassword"
                               placeholder="Confirm Password"
                               required>
                        <label for="inputConfirmPassword">Confirm password</label>
                      </div>

                      <div class="d-grid gap-2 mt-3">
                        <button class="btn btn-primary ripple py-3" type="submit">Sign Up</button>
                      </div>
                    </form>
                  </div>
                  <!-- LINKS -->
                  <div class="text-center">
                    <router-link to="/login" class="text-body">Already have an account? <span
                        class="text-link text-underline">Log in</span></router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Typical from 'vue-typical'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default {
  name: 'Register',
  metaInfo: {
    title: 'Register',
  },
  components: {
    Typical
  },
  data() {
    return {
      error: null,
      form: {}
    }
  },
  methods: {
    onClickLogin(byProvider) {
      let provider;

      if (byProvider === 'Twitter') {
        provider = new firebase.auth.TwitterAuthProvider()
      } else if (byProvider === 'Github') {
        provider = new firebase.auth.GithubAuthProvider()
      } else {
        provider = new firebase.auth.GoogleAuthProvider()
      }

      firebase.auth().signInWithPopup(provider)
          .then(() => this.$router.replace("/welcome"))
          .catch(err => {
            this.error = err.message
          })
    },

    onSubmit() {
      const db = firebase.firestore()

      firebase.auth()
          .createUserWithEmailAndPassword(this.form.email, this.form.password)
          .then(data => {
            data.user.updateProfile({displayName: this.form.name})
            console.log(this.form.name)

            db.collection('users').doc(data.user.uid)
                .set({
                  'displayName': this.form.name,
                }, {merge: true})
          })
          .then(() => this.$router.replace("/welcome"))
          .catch(err => this.error = err.message)
    }

  }
}
</script>